import React from 'react';
import Icon from './OpenPlayIcon';

const MapFilterToolbar = ({
  filterState,
  onFilterChange,
}) => {
  const availabilityOptions = [
    { value: 'all', label: '전체' },
    { value: 'available', label: '참가 가능' },
    { value: 'full', label: '마감' },
  ];

  const handleAvailabilityChange = (value) => {
    onFilterChange({
      ...filterState,
      availability: value,
    });
  };

  const clearAllFilters = () => {
    onFilterChange({
      dateRange: { start: null, end: null },
      availability: 'all',
    });
  };

  const activeFilterCount =
    (filterState.availability !== 'all' ? 1 : 0) +
    (filterState.dateRange.start || filterState.dateRange.end ? 1 : 0);

  return (
    <>
      <div className="hidden md:block sticky top-[72px] z-sticky bg-card border-b border-border shadow-elevation-1">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-2 py-1 rounded-lg bg-muted">
              {availabilityOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => handleAvailabilityChange(option.value)}
                  className={`
                    px-4 py-2 rounded-md font-medium transition-smooth touch-target
                    ${filterState.availability === option.value
                      ? 'bg-primary text-primary-foreground shadow-elevation-1'
                      : 'text-muted-foreground hover:text-foreground'
                    }
                  `}
                >
                  {option.label}
                </button>
              ))}
            </div>

            {activeFilterCount > 0 && (
              <button
                onClick={clearAllFilters}
                className="ml-auto flex items-center gap-2 px-4 py-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth touch-target"
              >
                <Icon name="XMarkIcon" size={20} />
                <span className="font-medium">필터 초기화</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MapFilterToolbar;
